var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid text-center"},[_c('div',{},[_c('div',{staticClass:"text-dark-50"},[_vm._v("Omaha Food Lovers © "+_vm._s(new Date().getFullYear())+" - All Rights Reserved")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }